<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="代理ID">
            <template slot="label">
              <I18Lang id="proxycust4" defaultText="姓名/用户ID/交易账号" />
            </template>
            <el-input
              v-model="queryForm.username"
              :placeholder="$t('proxycust128')"
            ></el-input>
          </el-form-item>
          <el-form-item label="生成时间">
            <template slot="label">
              <I18Lang id="text29" defaultText="生成时间" />
            </template>
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              @change="dateChange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('public22')"
              :end-placeholder="$t('public23')"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="类型">
            <template slot="label">
              <I18Lang id="public82" defaultText="类型" />
            </template>
            <el-select
              v-model="queryForm.gift_type"
              :placeholder="$t('public17')"
            >
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option
                v-for="(item, key) in giftTypeList"
                :label="item"
                :value="key"
                :key="key"
              ></el-option>
            </el-select>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryChange">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div
            class="btn kg-refresh btn-query-refresh"
            @click="resetChange"
          ></div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </el-form>
      </div>

      <div class="reset-table table" v-loading="isTableLoading">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="200" label="流水号" prop="id">
            <template slot="header">
              <I18Lang id="text14" defaultText="流水号" />
            </template>
          </el-table-column>

          <el-table-column width="190" label="代理ID">
            <template slot="header">
              <I18Lang id="proxymoney16" defaultText="代理ID" />
            </template>
            <template slot-scope="{ row }">
              {{ row.agent ? row.agent.account_id : "" }}
            </template>
          </el-table-column>

          <el-table-column width="190" label="用户ID" prop="account_id">
            <template slot="header">
              <I18Lang id="proxymoney89" defaultText="用户ID" />
            </template>
            <template slot-scope="{ row }">
              {{ row.user ? row.user.account_id : "" }}
            </template>
          </el-table-column>

          <el-table-column width="190"  label="赠金金额" prop="gift_amount">
            <template slot="header">
              <I18Lang id="text16" defaultText="赠金金额" />
            </template>
          </el-table-column>
          <el-table-column width="190" label="赠金佣金比例" prop="commission_rate">
            <template slot="header">
              <I18Lang id="text56" defaultText="赠金佣金比例" />
            </template>
            <template slot-scope="{ row }">
              {{ Number(row.commission_delta_rate || row.commission_rate || 0).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column width="190"  label="佣金" prop="commission">
            <template slot="header">
              <I18Lang id="text57" defaultText="佣金" />
            </template>
          </el-table-column>

          <el-table-column width="200" label="类型" prop="gift_type">
            <template slot="header">
              <I18Lang id="public82" defaultText="类型" />
            </template>
            <template slot-scope="scope">
              {{ giftTypeList[scope.row.gift_type] }}
            </template>
          </el-table-column>

          <el-table-column width="200" label="生成时间" prop="create_time">
            <template slot="header">
              <I18Lang id="text29" defaultText="生成时间" />
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <div class="sum">
            <I18Lang id="text58" defaultText="佣金总金额" />：{{
              tableData.sum
            }}
          </div>
          <el-pagination
            background
            :page-size="queryForm.size"
            @current-change="pageChange"
            layout="prev, pager, next"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formateObjToParamStr, serverUrl } from '@utils'
import { mapState } from 'vuex'
import cookie from '@utils/cookie'
import i18n from '@utils/i18n'
export default {
  name: 'record',
  data () {
    return {
      serverUrl,
      dateTime: '',
      queryForm: {
        gift_type: '',
        receive_type: '',
        username: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 15
      },
      writeType: '',
      currentData: {},
      isTableLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      giftTypeList: {
        1: i18n.t('text96'),
        2: i18n.t('text97')
      },
      statusList: {
        1: i18n.t('text43'),
        2: i18n.t('text44')
      }
    }
  },
  created () {
    this.getRecord()
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/giftCommissionDetailList?${formateObjToParamStr(params)}`
      )
    },
    getRecord () {
      this.isTableLoading = true
      this.$http
        .post('/api/agent/giftCommissionDetailList', this.queryForm)
        .then((result) => {
          this.tableData = result
        })
        .finally(() => {
          this.isTableLoading = false
        })
    },
    queryChange () {
      this.pageChange(1)
    },
    resetChange () {
      Object.keys(this.queryForm).map((item) => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryChange()
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss">
.page-main {
  .box-card-header {
    padding-bottom: 10px;

    .right {
      .statistics {
        font-size: 16px;
        color: #2a2a2a;
        letter-spacing: 0;
        line-height: 32px;
        vertical-align: top;
        margin-top: 5px;

        .num {
          color: #e61816;
        }
      }
    }
  }

  .box-card-content {
    .query {
      display: flex;
      justify-content: space-between;

      .btn-red {
        background: #e61816;
        border-color: #e61816;
      }
    }

    .table {
      ::v-deep .el-table {
        thead {
          tr,
          th {
            background: #f4f4f4;
            text-align: center;
          }
        }

        td {
          font-size: 14px;
          padding: 16px 0;
          text-align: center;
        }
      }

      .page {
        padding-top: 24px;
        text-align: right;

        ::v-deep .el-pager {
          .active {
            background: #e61816;
          }
        }
      }
    }
  }
}

.bank-info {
  p {
    margin-bottom: 10px;
  }
}

.operat-group {
  .operat-item {
    display: inline-block;
    margin-right: 15px;
    font-size: 14px;
    color: #0f75bd;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    text-decoration: underline;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.page {
  position: relative;

  .sum {
    position: absolute;
    left: 0;
    font-size: 14px;
    color: #fff;
  }
}
</style>
